<template>
  <layout-default-appbar :backTo="rota">
    {{$_titulo}}
  </layout-default-appbar>
</template>
<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { ROUTE_VISITA_INFO, ROUTE_APONTAMENTO_EMBARQUE_CADASTRO } from '@/constants/ROUTES';
import { VISITA_INFO_STORAGE, ROTA_STORAGE } from '@/constants/STORAGE';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default {
  name: 'ViewVideoAppbar',
  components: {
    LayoutDefaultAppbar,
  },
  computed: {
    $_titulo() {
      return this.titulo != null ? 'Alterar Video' : 'Capturar Video';
    },
    rota() {
      const anterior = sessionStorage.getItem(ROTA_STORAGE.anterior);
      if (anterior === ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name || anterior === 'apontamentoEmbarqueCadastro') {
        return ROUTE_APONTAMENTO_EMBARQUE_CADASTRO;
      }
      return ROUTE_VISITA_INFO;
    },
  },
  data() {
    return {
      titulo: getSessionStorage(VISITA_INFO_STORAGE.idinfo, null),
    };
  },
};
</script>
